<template>
  <v-layout wrap class="container px-2 py-0">
    <router-view />
  </v-layout>
</template>

<script>
import checkRouteAccess from '@/helpers/checkRouteAccess';

export default {
  name: 'AutosPage',
  beforeRouteEnter(to, from, next) {
    checkRouteAccess('car_view', next, to);
  },
};
</script>

<style lang="scss" scoped></style>
